import * as angular from 'angular';

import { ComponentDefinition, ObjectUser, IValueViewModel, Group } from '../../../models';

class GroupDeleteModalController implements angular.IComponentController {
    message: string;
    readonly item: IValueViewModel;
    readonly modalId: string;
    readonly usages: ObjectUser[];
    readonly yesFunction: (guid: string) => void;

    static $inject = [];

    $onChanges(changes: angular.IOnChangesObject) {
        if (changes['canDelete']) {
            this.message = changes['canDelete'].currentValue
                ? 'This group is used in the following object(s) which will also be deleted.'
                : 'This group is used in the following object(s) and cannot be deleted.';
        }
    }
}

export const wtGroupDeleteModal: ComponentDefinition = {
    componentId: 'wtGroupDeleteModal',
    controller: GroupDeleteModalController,
    template: require('./groupDeleteModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        canDelete: '<',
        item: '<',
        modalId: '@',
        usages: '<',
        yesFunction: '&'
    }
};